import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '../ui-x';
import { PRIMARY_NAV, isNavItemActive } from './navItems';

/**
 * Mobile bottom tab bar, per the reference talent shell. It carries the primary
 * nav group; the secondary group and account actions live in the drawer.
 */
const MobileTabBar = () => {
  const location = useLocation();

  return (
    <nav className='fixed bottom-0 left-0 right-0 z-40 border-t bg-card lg:hidden'>
      <div className='grid grid-cols-5'>
        {PRIMARY_NAV.map((item) => {
          const Icon = item.icon;
          const active = isNavItemActive(item, location.pathname);
          return (
            <NavLink
              key={item.key}
              to={item.path}
              className={cn(
                'flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium',
                active ? 'text-brand-orange' : 'text-muted-foreground'
              )}
            >
              <Icon className='h-5 w-5' />
              {item.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileTabBar;
